// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Wba-z","colorTextValue":"Xba-z","swatches":"Yba-z","collapseLink":"Zba-z","isCollapsed":"_ba-z","dropdown":"aca-z","disabled":"bca-z"};